import React from 'react';
import {
  CheckList,
  Code,
  UI,
  Architecture,
  Cloud,
  Compliance,
  Consulting,
  AppDev,
  AppTest,
  AppDesign,
  AppSupport,
  Integration,
  Security,
  Performance,
} from '../../../../assets/svg/index';

export const getActivityIcons = (): React.FC[] => [
  Integration,
  Consulting,
  AppDev,
  AppTest,
  AppDesign,
  AppSupport,

  Performance,
  Security,
  Code,
  CheckList,
  UI,
  Architecture,
  Cloud,
  Compliance,
];
